import * as Enums from '../shared/utilities/enums';
import { IAssignment } from '../module/models';
import { TestAssignment } from '../test/models';

export class Viewer {
  LessonAssignmentId: number;
  Videos: Array<Video>;
  Note: Note;
  CourseMaterials: Array<CourseMaterialsOfSameType>;
  CourseResources: Array<CourseMaterial>;
  ResumeTimeSeconds: number;
  PreferedLanguage: string;

  constructor(obj?: any) {
    this.LessonAssignmentId = obj && obj.LessonAssignmentId || 0;
    this.Videos = obj && obj.Videos && obj.Videos.map(t => <Array<Video>>(t)) || new Array<Video>();
    this.Note = obj && obj.Notes || null; //obj.Notes.map(t => <Array<Note>>(t)) || new Array<Note>();
    this.CourseMaterials = obj && obj.CourseMaterials && obj.CourseMaterials.map(t => <Array<CourseMaterialsOfSameType>>(t)) || new Array<CourseMaterialsOfSameType>();
    this.CourseResources = obj && obj.CourseResources && obj.CourseResources.map(t => <Array<CourseMaterial>>(t)) || new Array<CourseMaterial>();
    this.ResumeTimeSeconds = obj && obj.ResumeTimeSeconds || 0;
    this.PreferedLanguage = obj && obj.PreferedLanguage || null;
  }
}

export class Note {
  NotesId: number;
  LessonAssignmentId: number;
  Text: string;

  constructor(obj?: any) {
    this.NotesId = obj && obj.NotesId || 0;
    this.LessonAssignmentId = obj && obj.LessonAssignmentId || 0;
    this.Text = obj && obj.Text || null;
  }
}

export class NoteMessage {
  Show: boolean;
  Text: string;
  Status: Enums.SaveStatus
}

export class Locale {
  id: number;
  top: number;
  active: boolean;

  constructor(id: number, top: number, active: boolean) {
    this.id = id;
    this.top = top;
    this.active = active;
  }
}

export class CourseMaterial {
  CourseMaterialName: string;
  CourseMaterialPath: string;
  CourseMaterialType: string;
  CourseMaterialTypeId: number;
  CourseMaterialAction: CourseMaterialAction;

  constructor(obj?: any) {
    this.CourseMaterialName = obj && obj.CourseMaterialName || '';
    this.CourseMaterialPath = obj && obj.CourseMaterialPath || '';
    this.CourseMaterialType = obj && obj.CourseMaterialType || '';
    this.CourseMaterialTypeId = obj && obj.CourseMaterialTypeId || 0;
    this.CourseMaterialAction = obj && obj.CourseMaterialAction && obj.CourseMaterialAction.map(t => new CourseMaterialAction(t)) || null;
  }
}

export class CourseMaterialAction {
  Id: number;
  Action: string;

  constructor(obj?: any) {
    this.Id = obj && obj.Id || 0;
    this.Action = obj && obj.Action || '';
  }
}

export class CourseMaterialsOfSameType {
  CourseMaterialType: string;
  CourseMaterialId: number;
  CourseMaterials: Array<CourseMaterial>;

  constructor(obj?: any) {
    this.CourseMaterialType = obj && obj.CourseMaterialType || '';
    this.CourseMaterialId = obj && obj.CourseMaterialId || 0;
    this.CourseMaterials = obj && obj.CourseMaterials && obj.CourseMaterials.map(t => <Array<CourseMaterial>>(t)) || new Array<CourseMaterial>();
  }
}

export class MediaSource {
  type: string;
  src: string;

  constructor(obj?: any) {
    this.type = obj && obj.type || '';
    this.src = obj && obj.src || '';
  }
}

export class VideoSource extends MediaSource {
  label: string;
  selected: boolean;

  constructor(obj?: any) {
    super(obj);
    this.label = obj && obj.label || '';
    this.selected = obj && obj.selected || false;
  }
}

export class VideoCaption {
  Id: number;
  VideoTimingMarkId: number;
  CaptionText: string;
  IsImportant: boolean;
  LanguageCode: string;
}

export class VideoTimingMark {
  Id: number;
  VideoId: number;
  TimingMark: number;
  VideoCaptions: Array<VideoCaption>;

  constructor(obj?: any) {
    this.Id = obj && obj.Id || 0;
    this.VideoId = obj && obj.VideoId || 0;
    this.TimingMark = obj && obj.TimingMark || 0;
    this.VideoCaptions = obj && obj.VideoCaptions && obj.VideoCaptions.map(t => <Array<VideoCaption>>(t)) || new Array<VideoCaption>();
  }
}

export class Video {
  Id: number;
  LessonId: number;
  Path: string;
  Duration: string;
  VideoTimingMarks: Array<VideoTimingMark>;
  UrlFallBacks: Array<VideoSource>;

  constructor(obj?: any) {
    this.Id = obj && obj.Id || 0;
    this.LessonId = obj && obj.LessonId || 0;
    this.Path = obj && obj.Path || '';
    this.Duration = obj && obj.Duration || '';
    this.VideoTimingMarks = obj && obj.VideoScripts && obj.VideoScripts.map(t => <Array<VideoTimingMark>>(t)) || new Array<Note>();
    this.UrlFallBacks = obj && obj.UrlFallBacks && obj.UrlFallBacks.map(t => <Array<VideoSource>>(t)) || new Array<Note>();
  }
}

export class LessonAssignment implements IAssignment {
  Id: number;
  AssignmentStatusId: Enums.AssignmentStatus;
  AssignmentDate: Date;
  StartDate: Date;
  EndDate: Date;
  Lesson: Lesson;
  IsTest = false;
  TestAssignments: Array<TestAssignment>;
  LessonAssignmentId: number;
  ModuleId : number;
  ModuleOrdinal: number;
}

export class Lesson {
  Id: number;
  SectionId: number;
  SectionName: string;
  Ordinal: number;
  Title: string;
  Videos: Array<Video>;
  LessonAssignmentId: number;
  LessonAssignment: LessonAssignment;

  constructor() {
  }
}
